var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INLINE_STYLES } from '../helper';
var IconS24UserTie24 = function (_a) {
    var inline = _a.inline, title = _a.title, rest = __rest(_a, ["inline", "title"]);
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 32 32", fill: "currentColor" }, rest, { style: __assign(__assign({}, (inline && INLINE_STYLES)), rest.style) }),
        title && React.createElement("title", null, title),
        React.createElement("path", { d: "M21.333 14.667c0.832-1.088 1.333-2.468 1.333-3.964 0-0.012-0-0.025-0-0.038v0.002c0-3.682-2.985-6.667-6.667-6.667s-6.667 2.985-6.667 6.667v0c-0 0.011-0 0.023-0 0.036 0 1.497 0.501 2.876 1.345 3.98l-0.012-0.016h-4v12h2.667v-9.333h4l-1.333 5.333 4 4 4-4-1.333-5.333h4v9.333l2.667-1.333v-10.667zM16 6.667c2.209 0 4 1.791 4 4s-1.791 4-4 4c-2.209 0-4-1.791-4-4v0c0-2.209 1.791-4 4-4v0zM16 22.893l-1.040-1.040 1.040-4.147 1.040 4.147z" })));
};
export default IconS24UserTie24;
//# sourceMappingURL=IconS24UserTie24.js.map